export interface entidadGeneral {
    entidadGeneral: number,
    numero: number,
    usuario: string,
    codigoTipoEntidadGeneral: number,
    tipo: string,
    nombre: string,
    timeCreate: Date,
    timeUpdate: Date,
    email: string | null,
    campoBusqueda: string;
}

export const tipoEntidadGeneral: any = {
    //ENTIDAD:                {codigo:1, descripcion: "Entidad"},
    ASOCIACION_PRESTADORES: { codigo: 2, descripcion: "Asociación Prestadores" },
    PRESTADOR: { codigo: 3, descripcion: "Prestador" },
    PERSONA: { codigo: 4, descripcion: "Persona" },
    PROVEEDOR: { codigo: 5, descripcion: "Proveedor" },
    //DELEGACION_ISSYS:       {codigo:6, descripcion: "Delegación ISSyS"},
    //BENEFICIO_HABERES:      {codigo:7, descripcion: "Benediciario de Haberes"},
    ORGANISMO: { codigo: 8, descripcion: "Organismo" },
    //SUCURSAL_PROVEEDOR:     {codigo:9, descripcion: "Sucursal Proveedor"},
    COMPLEJO_TURISTICO: { codigo: 10, descripcion: "Complejo Turístico" },
    //JUZGADO:                {codigo:11, descripcion: "Entidad"},
    MUTUAL: { codigo: 12, descripcion: "Mutual" },
    PRESCRIPTOR: { codigo: 13, descripcion: "Prescriptor" }
};